/**
 * React dependencies
 */

import React from 'react';

/**
 * DWT dependencies
 */

import { arrowRightIcon } from '../img/icons';

/**
 * Article
 *
 * A component to render a single WordPress article
 *
 * @param {Object}  props
 * @param {Array}   props.articleData
 * @param {Boolean} props.endReached
 *
 */

const Article = ({ articleData, endReached }) => {
  const featuredImage = articleData._embedded?.self?.[0]?.image?.url || '';
  const featuredImageAlt = articleData._embedded?.self?.[0]?.image?.alt || '';

  return (
    <div className={`py-[30px] border-b-[0.5px] border-[#121212] flex flex-col md:flex-row ${endReached ? 'last:border-b-0' : ''}`}>
      {featuredImage && (
        <a href={ articleData.url }>
          <div className="h-[160px] min-h-[160px] w-[160px] min-w-[160px] bg-[#c4c4c4] mr-[20px] mb-30 md:mb-0 relative overflow-hidden">
            <img className="object-cover object-center absolute inset-0 w-full h-full" src={featuredImage} alt={featuredImageAlt} />
          </div>
        </a>
      )}
      <li>
        <a href={ articleData.url } className="no-underline"><strong><p className="underline underline-offset-4 font-bold text-18 mt-0" dangerouslySetInnerHTML={ { __html: articleData.title } } /></strong></a>

        <p className="article-result-text paragraph-2 my-[15px] line-clamp-5 md:line-clamp-4 text-ellipsis" dangerouslySetInnerHTML={ { __html: articleData._embedded?.self[0]?.excerpt?.rendered } } />

        <div className="flex items-center">
          <a href={ articleData.url } className="no-underline hover:underline underline-offset-4 font-medium mr-10">Read More</a>
          {arrowRightIcon}
        </div>
      </li>
    </div>
  );
};

export default Article;
